import { render, staticRenderFns } from "./EmailFormModal.vue?vue&type=template&id=bbb10244&"
import script from "./EmailFormModal.vue?vue&type=script&lang=js&"
export * from "./EmailFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports